import React from 'react';
import PropTypes from 'prop-types';
import ContentCol from './ContentCol';
import './SignupContentRow.scss';


const propTypes= {
    rCols: PropTypes.array,
};


export default class SignupContentRow extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const{rCols} = this.props;

        return(
            <div className='ucontent-row-holder'>
                {this.props.rCols.map((col, index) => (
                    <ContentCol key={index} contentCol={col}/>
                ))}
            </div>
        );
    }
};

SignupContentRow.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/SignupContentRow/index.js